import { render, staticRenderFns } from "./menuNav.vue?vue&type=template&id=aae705a4&scoped=true&"
import script from "./menuNav.vue?vue&type=script&lang=js&"
export * from "./menuNav.vue?vue&type=script&lang=js&"
import style0 from "./menuNav.vue?vue&type=style&index=0&id=aae705a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae705a4",
  null
  
)

export default component.exports